import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromShipmentPackages from './+state/shipment-packages.reducer';
import {ShipmentPackagesEffects} from './+state/shipment-packages.effects';
import {ShipmentPackagesFacade} from './+state/shipment-packages.facade';
import {SharedStoresShipmentPackagesConfig} from "./shared-stores-shipment-packages.config";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShipmentPackages.SHIPMENTPACKAGES_FEATURE_KEY,
            fromShipmentPackages.reducer
        ),
        EffectsModule.forFeature([ShipmentPackagesEffects]),
    ],
    providers: [ShipmentPackagesFacade],
})
export class SharedStoresShipmentPackagesModule {

    static forFeature(
        config: SharedStoresShipmentPackagesConfig
    ): ModuleWithProviders<SharedStoresShipmentPackagesModule> {
        return {
            ngModule: SharedStoresShipmentPackagesModule,
            providers: [config.service]
        }
    }
}
